import { useEffect } from 'react';

/*
 *  Ported code from react-aria-components as of V.1.2.1 use the original commit in the repo
 *  to diff any added code since the original commit.
 */
// This behavior moved from useOverlayTrigger to useOverlayPosition.
// For backward compatibility, where useOverlayTrigger handled hiding the popover on close,
// it sets a close function here mapped from the trigger element. This way we can avoid
// forcing users to pass an onClose function to useOverlayPosition which could be considered
// a breaking change.

// forking  note
// note this should be pulling from lodash here: "node_modules\@types\lodash\"
// checked with aria implementation and is getting from the same
var onCloseMap = new WeakMap();

/** @private */
function useCloseOnScroll(opts) {
  var triggerRef = opts.triggerRef,
    isOpen = opts.isOpen,
    onClose = opts.onClose;
  useEffect(function () {
    if (!isOpen || onClose === null) {
      return;
    }
    var onScroll = function onScroll(e) {
      // Ignore if scrolling an scrollable region outside the trigger's tree.
      var target = e.target;
      // window is not a Node and doesn't have contain, but window contains everything
      if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) {
        return;
      }
      var onCloseHandler = onClose || onCloseMap.get(triggerRef.current);
      if (onCloseHandler) {
        onCloseHandler();
      }
    };
    //@ts-expect-error
    window.addEventListener('scroll', onScroll, true);
    return function () {
      //@ts-expect-error
      window.removeEventListener('scroll', onScroll, true);
    };
  }, [isOpen, onClose, triggerRef]);
}

export { useCloseOnScroll as default, onCloseMap };
//# sourceMappingURL=use-close-on-scroll.esm.js.map
